import { isMobile } from "../utils/utils";
import { DEVICE } from "../utils/constant";
import { LocalStorage } from "./LocalStorage";

export class BannerConfig {
  constructor(device, language, delivery, currency, tier, platform, startTime, endTime, dataId, slug) {
    this.device = device;
    this.language = language;
    this.delivery = delivery;
    this.currency = currency;
    this.tier = tier;
    this.platform = platform;
    this.startTime = startTime;
    this.endTime = endTime;
    this.dataId = dataId;
    this.slug = slug;
  }

  static fromApiObject(input) {
    if (input) {
      let result = {};
      let configs = input.split("{:}");
      configs.forEach(config => {
        let temp = config.split("|");
        if (temp.length > 2) {
          result[temp[0]] = []
          temp.forEach((item, index) => {
            if (index > 0) {
              result[temp[0]].push(item);
            }
          });
        } else {
          result[temp[0]] = temp[1];
        }
      });
      return new BannerConfig(
        result[this.ARG_CONFIG.DEVICE],
        result[this.ARG_CONFIG.LANGUAGE],
        result[this.ARG_CONFIG.DELIVERY],
        result[this.ARG_CONFIG.CURRENCY],
        result[this.ARG_CONFIG.TIER],
        result[this.ARG_CONFIG.PLATFORM],
        result[this.ARG_CONFIG.START_TIME],
        result[this.ARG_CONFIG.END_TIME],
        result[this.ARG_CONFIG.DATA_ID],
        result[this.ARG_CONFIG.SLUG],
      )
    }

    return new BannerConfig();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => BannerConfig.fromApiObject(item));
    }

    if (input && (typeof (input) === "object" || typeof (input) === "string")) {
      return [BannerConfig.fromApiObject(input)];
    }

    return [];
  }

  isValidConfig() {
    let valid = true, path = window.location.pathname;
    if (this.slug?.length && ((typeof (this.slug) === "string" && this.slug === path) || (Array.isArray(this.slug) && this.slug.includes(path)))) return true;
    if (this.device && this.device !== (isMobile() ? DEVICE.MOBILE : DEVICE.DESKTOP)) return false;
    if (this.language && this.language !== LocalStorage.getLanguage()) return false;

    if (this.startTime && this.endTime) {
      let today = new Date();
      var sd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), this.startTime.split(":")[0], this.startTime.split(":")[1] || "00", this.startTime.split(":")[2] || "00");
      var ed = new Date(today.getFullYear(), today.getMonth(), today.getDate(), this.endTime.split(":")[0], this.endTime.split(":")[1] || "00", this.endTime.split(":")[2] || "00");
      if (!(today > sd && today < ed)) return false;
    }
    return valid;
  }

  static ARG_CONFIG = {
    DEVICE: "device",
    LANGUAGE: "lang",
    DELIVERY: "delivery",
    CURRENCY: "currency",
    TIER: "tier",
    PLATFORM: "platform",
    START_TIME: "start_time",
    END_TIME: "end_time",
    DATA_ID: "data_id",
    SLUG: "slug"
  }
}